import angular from 'angular';

/* @ngInject */
export default () => ({
	restrict: 'A',
	scope: {
		callback: '&onVisible',
		message: '=model',
	},
	link: function link(/** @type {any} */ scope, /** @type {any} */ element) {
		const threshold = 0.75;
		const { message } = scope;

		/** @type {IntersectionObserver} */
		let observer;

		/**
		 * @param {any[]} changes
		 */
		function onChange(changes) {
			for (const change of changes) {
				if (change.intersectionRatio >= threshold) {
					scope.callback();
					observer.unobserve(change.target);
				}
			}
		}

		if (message.status === 'sent') {
			observer = new IntersectionObserver(onChange, {
				threshold,
			});
			const elementToObserve = angular.element(element)[0];

			observer.observe(elementToObserve);
		}
	},
});
